module.exports = __webpack_public_path__ + "media/images/btn_create_season-87324e61fe2877e133ccc85864dc624a.gif";